<template lang="pug">

//- Трек-номера в таблице: в строке виден первый, остальные — «+N».
//- По «+N» список раскрывается прямо в строке (не всплывающим окном —
//- так менеджерам удобнее искать глазами, решение владельца 30.10),
//- повторный клик сворачивает; «Копировать все» остаётся
span.track-cell(v-if="tracks.length", :class="{ 'is-open': open }")
  template(v-if="!open")
    span.track-cell__item {{ tracks[0] }}
    a.track-cell__more.ds-link(
      v-if="tracks.length > limit"
      href="#"
      :title="_('Все трек-номера')"
      @click.prevent.stop="open = true"
    ) +{{ tracks.length - limit }}
  template(v-else)
    span.track-cell__list
      span.track-cell__item(
        v-for="(track, index) in tracks"
        :key="index"
      ) {{ track }}
    span.track-cell__actions
      a.track-cell__more.ds-link(
        href="#"
        @click.prevent.stop="open = false"
      ) {{ _('Свернуть') }}
      a.track-cell__more.ds-link(
        href="#"
        @click.prevent.stop="copyAll"
      ) {{ _('Копировать все') }}

</template>

<script>
// разделители, которыми треки записаны в одном поле:
// «a, b», «a . b» (так пишут на складе), «a / b», «a; b», перенос строки
const SEPARATORS = /\s*[,;/\n]\s*|\s+\.\s*|\s+/;

export default {
  name: 'track-cell',
  props: {
    value: { type: String, default: '' },
    limit: { type: Number, default: 1 },
  },
  data() {
    return { open: false };
  },
  computed: {
    tracks() {
      // список грузов отдаёт треки мест как «(a, b, c)»
      return String(this.value || '')
        .replace(/^\s*\(|\)\s*$/g, '')
        .split(SEPARATORS)
        .map(track => track.replace(/^[.(]+|[.)]+$/g, '').trim())
        .filter(Boolean);
    },
  },
  watch: {
    // другая строка после смены страницы/фильтра — снова свёрнуто
    value() {
      this.open = false;
    },
  },
  methods: {
    copyAll() {
      const text = this.tracks.join('\n');
      const done = () => this.$toast.success(this._('Скопировано'));

      // http без https или браузер не дал доступ к буферу: старый способ
      const fallback = () => {
        const area = document.createElement('textarea');
        area.value = text;
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        document.body.removeChild(area);
        done();
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done, fallback);
        return;
      }
      fallback();
    },
  },
};
</script>

<style>
.track-cell {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  line-height: 1.35;
}

.track-cell.is-open {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  user-select: text;
}

.track-cell__item {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.track-cell__more {
  font-size: 12px;
  white-space: nowrap;
}

.track-cell__list {
  display: flex;
  flex-direction: column;
}

.track-cell__actions {
  display: flex;
  gap: 10px;
}
</style>
